import { badgeVariants } from '@/components/ui/badge'

export const statusConfig = (t: (key: string) => string) => ({
  Active: {
    label: t('common.active'),
    className: 'badge-success',
  },
  Inactive: {
    label: t('common.inactive'),
    className: 'badge-inactive',
  },
  Blacklisted: {
    label: t('vehicles.blacklisted'),
    className: badgeVariants({ variant: 'destructiveSoft' }),
  },
})

/** Centralised styling for booking/order statuses returned by the API. */
export const orderStatusConfig = (t: (key: string) => string) => ({
  preliminary: {
    label: t('booking.orderStatuses.preliminary'),
    className: 'bg-muted/20 text-muted-foreground border-muted/30',
  },
  created: {
    label: t('booking.orderStatuses.created'),
    className: 'bg-warning/10 text-warning border-warning/20',
  },
  inShop: {
    label: t('booking.orderStatuses.inShop'),
    className: badgeVariants({ variant: 'primarySoft' }),
  },
  // Slightly stronger tint than `inShop` to stay visually distinct while still
  // anchored to the shared `primarySoft` text color.
  startService: {
    label: t('booking.orderStatuses.startService'),
    className: `${badgeVariants({ variant: 'primarySoft' })} bg-primary/15 border-primary/25`,
  },
  pickedUp: {
    label: t('booking.orderStatuses.pickedUp'),
    className: badgeVariants({ variant: 'accentSoft' }),
  },
  finished: {
    label: t('booking.orderStatuses.finished'),
    className: badgeVariants({ variant: 'successSoft' }),
  },
})
